// The VPN's flow records (SaaS). Trial-aliased to a stand-in that renders
// nothing: the trial build keeps no flow records, so these screens would only
// ever be empty.
import { IS_TRIAL } from '@/lib/edition';

/** Whether this build has flow records: true here, since the trial build
 *  replaces this module; written as a flag for code that can't tell. */
export const VPN_FLOWS = !IS_TRIAL;
export { SessionFlows } from './components/SessionFlows';
export { FlowRetentionCard } from './components/FlowRetentionCard';
export { VpnLookup } from './pages/VpnLookup';
